import { getNavigationItemsProps, navigationItem } from './types'
import { routes } from 'utils/routes'
import { Language } from 'types/language'

export const getNavigationItems = ({ language, t }: getNavigationItemsProps): navigationItem[] => [
  // ABOUT US
  {
    text: t('aboutUs', 'Over ons'),
    isActiveRoutes: ['/about', '/careers', '/faq'],
    destination: '/#',
    subItems: [
      {
        text: t('mission', 'Missie'),
        destination: routes(language).about
      },
      {
        text: t('team', 'Team'),
        destination: `${routes(language).about}#team`
      },
      {
        text: t('careers', 'Jobs'),
        destination: routes(language).jobs
      },
      {
        text: t('faq', 'Veelgestelde vragen'),
        destination: routes(language).faq
      }
    ]
  },

  // PRODUCERS
  {
    text: t('producers', 'Opwekkers'),
    isActiveRoutes: ['/producers'],
    destination: routes(language).producers
  },

  // BECOME PRODUCER
  {
    text: t('areYouProducer', 'Word opwekker'),
    isActiveRoutes: ['/mini-generators'],
    destination: '/#',
    subItems: [
      {
        text: t('producer', 'Opwekker'),
        destination: `${routes(language).home}#producer`
      },
      {
        text: t('miniProducer', 'Mini-opwekker'),
        destination: routes(language).miniGenerators
      }
    ]
  },

  // PRICE
  {
    text: t('pricing', 'Prijzen'),
    isActiveRoutes: ['/pricing'],
    destination: routes(language).pricing
  },

  // PROJECTS
  {
    text: t('projects', 'Projecten'),
    isActiveRoutes: ['/projects'],
    destination: routes(language).projects,
    showOnLanguage: Language.FRENCH
  },

  // ENCYCLOPEDIA
  {
    text: t('encyclopedia', 'Encyclopedie'),
    isActiveRoutes: ['/encyclopedia'],
    destination: routes(Language.DUTCH).encyclopedia,
    showOnLanguage: Language.DUTCH
  }
]
